import axiosConfig from "../../../../../config/axiosConfig";
import helpers from "../../../../../common/helpers/common";

const ProjectApi = () => {
  const getListProject = async (params: {
    page: number;
    size: number;
    sortBy?: string;
    sortType?: string;
    keyword?: string;
    from?: string;
    to?: string;
    hasTimesheets?: boolean;
  }): Promise<any> => {
    try {
      const url = "/project/manager";
      const response = await axiosConfig.get(url, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  return {
    getListProject,
  };
};

export default ProjectApi;
